import { render, staticRenderFns } from "./SupplierDocumentDetail.vue?vue&type=template&id=5103dc95&scoped=true&"
import script from "./SupplierDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierDocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDocumentDetail.vue?vue&type=style&index=0&id=5103dc95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103dc95",
  null
  
)

export default component.exports